module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiperWrap"
  }, [_c('div', {
    directives: [{
      name: "swiper",
      rawName: "v-swiper:mySwiper",
      value: (_vm.swiperOption),
      expression: "swiperOption",
      arg: "mySwiper"
    }]
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.carouselImgData), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "swiper-slide"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: ("/news/" + (_vm.getUrlTitle(_vm.subtit)) + "/" + (_vm.getUrlTitle(item.title)) + "/" + (item.id))
        }
      }
    }, [(index === 0) ? _c('img', {
      staticClass: "swiper-lazy",
      attrs: {
        "src": _vm.getImgSrc(item.thumb)
      }
    }) : _c('img', {
      staticClass: "swiper-lazy",
      attrs: {
        "data-src": _vm.getImgSrc(item.thumb)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper-lazy-preloader swiper-lazy-preloader-white"
    })]), _vm._v(" "), _c('div', {
      staticClass: "header-mask"
    }), _vm._v(" "), _c('p', {
      staticClass: "titleWord"
    }, [_vm._v(_vm._s(item.title))])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination-bullets"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20e7dc25","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel.vue
// module id = 553
// module chunks = 4 5